import { render } from "./TermsFrame.vue?vue&type=template&id=659df431&scoped=true"
import script from "./TermsFrame.vue?vue&type=script&lang=js"
export * from "./TermsFrame.vue?vue&type=script&lang=js"

import "./TermsFrame.vue?vue&type=style&index=0&id=659df431&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659df431"]])

export default __exports__